import { dropdownList } from "../dropdown.shared.styles.js";
import { c } from "react/compiler-runtime";
import { jsx } from "react/jsx-runtime";
//#region src/components/menu/menu.list.tsx
/** Scrollable layout container for Menu items. */
var MenuList = (t0) => {
	const $ = c(2);
	const { children } = t0;
	let t1;
	if ($[0] !== children) {
		t1 = /* @__PURE__ */ jsx("div", {
			className: dropdownList,
			children
		});
		$[0] = children;
		$[1] = t1;
	} else t1 = $[1];
	return t1;
};
//#endregion
export { MenuList };
